<table class="table table-striped" data-test="reportBuildingsTable">
  <thead>
    <th style="width: 25%">{{ 'building' | translate }}</th>
    <th class="text-end">{{ 'function' | translate }}</th>
    <th class="text-end">{{ 'building.year' | translate }}</th>
    <th class="text-end">{{ translationKey('buildings.energyLabel') | translate }}</th>
    <th class="text-end">{{ translationKey('buildings.energyLabelValidUntil') | translate }}</th>
    @if (hasEnergyLabelRequirementLicense()) {
      <th class="text-end">{{ translationKey('buildings.energyLabelObligation') | translate }}</th>
    }
  </thead>
  <tbody>
    @for (data of portfolioBuildingsRoadmapBuildings(); track data.building.id) {
      <tr>
        <td>
          <div class="position-relative">
            <div class="d-flex">
              <cfp-street-view-image
                class="d-flex align-items-center"
                [buildingId]="data.building.id"
                [address]="data.building.displayAddress"
                [size]="'sm'"
                [showMonumentIcon]="data.building.monument"
              />
              <div
                class="ms-3 mb-0"
                [buildingAddress]="data.building.displayAddress"
                [countryCode]="data.building.countryCode"
              ></div>
            </div>
            <div class="badges">
              @if (data.roadmap) {
                <cfp-badge [badgeStyle]="'secondary'">{{ translationKey('plan') | translate }}</cfp-badge>
              }
              @if (data.building.ownershipStatus === OwnershipStatusDTO.PLANSTOSELLBEFORE2030) {
                <cfp-badge [badgeStyle]="'primary'" [classes]="'ms-2'">{{
                  translationKey('sell') | translate
                }}</cfp-badge>
              }
            </div>
          </div>
        </td>
        <td class="text-end">
          {{ `objecttype.${data.building.objectType}` | translate }}
        </td>
        <td class="text-end">
          {{
            data.building.constructionPeriod
              ? (data.building.constructionPeriod | translateConstructionPeriod)
              : data.building.year
          }}
        </td>
        <td class="text-end">
          <div class="d-flex align-items-center justify-content-end">
            <div class="d-inline-flex">
              @if (data.energyLabels?.currentEnergyLabel) {
                <cfp-energy-label
                  [energyLabel]="data.energyLabels.currentEnergyLabel"
                  [clarificationEnergyLabel]="data.energyLabels.clarificationLabel"
                  [showClarificationInline]="true"
                  [labelSituationType]="data.energyLabels.labelSituationType"
                  [size]="'sm'"
                />
                <cfp-icon
                  [icon]="'arrow-right'"
                  [iconSize]="'large'"
                  [classes]="'mx-3'"
                  [class.opacity-0]="!data.energyLabels.improvedEnergyLabel || !data.roadmap"
                />
                <cfp-energy-label
                  [energyLabel]="data.energyLabels.improvedEnergyLabel"
                  [size]="'sm'"
                  class="energy-label-fixed-width"
                  [class.opacity-0]="!data.energyLabels.improvedEnergyLabel || !data.roadmap"
                />
              }
            </div>
          </div>
        </td>
        <td class="text-end">
          @let isRegistered =
            data.energyLabels?.currentEnergyLabel?.labelType === EnergyLabelTypeDTO.REGISTERED ||
            data.energyLabels?.clarificationLabel?.labelType === EnergyLabelTypeDTO.REGISTERED;
          @let validUntil =
            data.energyLabels?.currentEnergyLabel?.validUntil ?? data.energyLabels?.clarificationLabel?.validUntil;
          @if (validUntil && isRegistered) {
            {{ validUntil | date: 'longDate' }}
          }
        </td>
        @if (hasEnergyLabelRequirementLicense()) {
          <td class="text-end">
            @defer {
              <cfp-energy-label-requirement-status
                class="d-inline-flex"
                [energyLabelRequirement]="mapToEnergyLabelRequirement(data)"
                [iconClasses]="'me-2 d-print-none'"
              />
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
